import React, { useEffect, useRef } from 'react';

const EventsMap = ({ events }) => {
  const mapRef = useRef(null);
  const markersRef = useRef([]);
  const googleMapRef = useRef(null);

  useEffect(() => {
    if (!window.google || !mapRef.current) return;

    // Remove old markers if any
    markersRef.current.forEach(marker => {
      try {
        marker.setMap(null);
      } catch (e) {
        // Ignore errors if marker is already removed
      }
    });
    markersRef.current = [];

    // Remove previous map instance if exists
    if (googleMapRef.current) {
      // Remove all children from mapRef to avoid orphan nodes
      while (mapRef.current.firstChild) {
        try {
          mapRef.current.removeChild(mapRef.current.firstChild);
        } catch (e) {
          // Ignore errors if node is already removed
        }
      }
      googleMapRef.current = null;
    }

    // Initialize map
    const map = new window.google.maps.Map(mapRef.current, {
      center: events.length > 0 ? events[0].coordinates : { lat: 37.7749, lng: -122.4194 },
      zoom: 10,
    });
    googleMapRef.current = map;

    // Add new markers
    events.forEach(event => {
      if (event.coordinates && event.coordinates.lat && event.coordinates.lng) {
        const marker = new window.google.maps.Marker({
          position: event.coordinates,
          map,
          title: event.title,
        });
        markersRef.current.push(marker);
      }
    });

    // Cleanup on unmount
    return () => {
      markersRef.current.forEach(marker => {
        try {
          marker.setMap(null);
        } catch (e) {
          // Ignore errors if marker is already removed
        }
      });
      markersRef.current = [];
      if (mapRef.current) {
        while (mapRef.current.firstChild) {
          try {
            mapRef.current.removeChild(mapRef.current.firstChild);
          } catch (e) {
            // Ignore errors if node is already removed
          }
        }
      }
      googleMapRef.current = null;
    };
  }, [events]);

  return <div ref={mapRef} style={{ width: '100%', height: '400px' }} />;
};

export default EventsMap;